import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  variant?: 'default' | 'destructive'
  title?: string
  description?: string
  content?: React.ReactNode

  onConfirm: () => Promise<void> | void
  loading?: boolean
}

export function ConfirmDialog({
  open,
  onOpenChange,
  variant = 'default',
  title = 'ยืนยันการลบ',
  description = 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้',
  content,
  onConfirm,
  loading,
}: Props) {
  const { t } = useTranslation()
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="flex flex-col max-h-[85vh] sm:max-w-lg overflow-hidden">
        <AlertDialogHeader className="flex-1 overflow-y-auto">
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>

          {content}
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>{t('common.cancel')}</AlertDialogCancel>

          <AlertDialogAction
            data-testid="confirm-dialog-confirm"
            onClick={onConfirm}
            disabled={loading}
            className={
              variant === 'destructive'
                ? 'bg-destructive text-white hover:bg-destructive/90 focus:ring-destructive'
                : ''
            }
          >
            {loading ? t('common.deleting') : t('common.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
